export default "assets/images/79113264fa9f6fda8f0f8ad0166dadf5.png";